export const convertPrimitiveArrayToObject = (
  array = [],
  booleanValue = true,
) => {
  const initialValue = {};
  return array.reduce((value, item) => {
    return {
      ...value,
      [item]: booleanValue,
    };
  }, initialValue);
};
